// extracted by mini-css-extract-plugin
export default {"box":"pfZl_ZVSAuu0AYCSsJ1_","filterRow":"TrZTaw_lvT1wvNceWVzi","formBox":"yqvqYdPxXUE6SgUjlNZx"};